import React from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Box, Text, Button, VStack, Image } from "@chakra-ui/react";

import img1 from "../../assets/intro-image.png";

const IntroductionPage = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/register");
  };

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <Flex
      justify="center"
      align="center"
      height="100vh"
      bg="white"
      border="1px solid #2a4567"
      position="relative"
      boxShadow="0px 4px 20px rgba(0, 0, 0, 0.25)"
    >
      {/* Left Content */}
      <Box
        flex={1}
        justifyContent="center"
        alignItems="center"
        display={"flex"}
      >
        <VStack align="flex-start" spacing={5} width={400}>
          <Text
            fontFamily={"PlusJakartaSansSemiBold"}
            fontSize={"48px"}
            lineHeight={"60px"}
            color={"#000000"}
          >
            Join 6,000+ Dummy Text With KWC
          </Text>
          <VStack align="flex-start" spacing={2}>
            <Flex alignItems={"center"} gap={2}>
              <Image
                src={require("assets/svgs/check.svg").default}
                width={"12px"}
                height={"9px"}
              />
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"18px"}
                lineHeight={"28px"}
                color={"#898989"}
              >
                Dummy Text Line number 1 of Overview
              </Text>
            </Flex>

            <Flex alignItems={"center"} gap={2}>
              <Image
                src={require("assets/svgs/check.svg").default}
                width={"12px"}
                height={"9px"}
              />
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"18px"}
                lineHeight={"28px"}
                color={"#898989"}
              >
                Dummy Text Line number 1 of Overview
              </Text>
            </Flex>
            <Flex alignItems={"center"} gap={2}>
              <Image
                src={require("assets/svgs/check.svg").default}
                width={"12px"}
                height={"9px"}
              />
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"18px"}
                lineHeight={"28px"}
                color={"#898989"}
              >
                Dummy Text Line number 1 of Overview
              </Text>
            </Flex>
          </VStack>
          <Flex mt={5} gap={4}>
            <Button
              bgColor={"#456EFF"}
              colorScheme="#456EFF"
              borderRadius={"12px"}
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"16px"}
              lineHeight={"20px"}
              color={"#FFFFFF"}
              textAlign={"center"}
              w={"175px"}
              h={"48px"}
              onClick={() => navigate("/Join-our-community")}
            >
              Get Started
            </Button>
            <Button
              variant="outline"
              bgColor={"transparent"}
              colorScheme="#456EFF"
              borderRadius={"12px"}
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"16px"}
              lineHeight={"20px"}
              color={"#456EFF"}
              textAlign={"center"}
              w={"175px"}
              h={"48px"}
            >
              Cancel
            </Button>
          </Flex>
        </VStack>
      </Box>

      {/* Right Image */}
      <Box flex={1}>
        <Image
          src={img1}
          alt="Kids Fashion"
          objectFit="cover"
          width={589}
          height={440}
        />
      </Box>
    </Flex>
  );
};

export default IntroductionPage;
